//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    confirmName: {
      type: String,
      default: '确认'
    },
    cancelName: {
      type: String,
      default: '取消'
    }
  },
  data () {
    return {
      action: '',
      callback: null,
      message: '确认执行该操作吗？',
      title: '提醒'
    }
  },
  created () {
    document.addEventListener('keydown', this.l_closeModalWithEsc)
  },
  destroyed () {
    document.removeEventListener('keydown', this.l_closeModalWithEsc)
  },
  watch: {},
  methods: {
    l_doCallback (action) {
      this.action = action
      if (this.action && this.callback) {
        this.callback(this.action)
      }
    },
    e_confirm () {
      this.$emit('confirm')
      this.l_doCallback('confirm')
      this.l_close()
    },
    e_cancel () {
      this.$emit('cancel')
      this.l_doCallback('cancel')
      this.l_close()
    },
    l_closeModalWithEsc (e) {
      if (e.keyCode === 27 && this.visible) {
        this.l_close()
      }
    },
    l_closeModalWithMouse (e) {
      if (this.visible) {
        this.l_close()
      }
    },
    l_close () {
      this.$emit('update:visible', false)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/confirmDialog/confirmDialog.vue